import { getChatgroupinvitationsFromUserId } from './chatgroupinvitationSelectors';

export const isUserInvitedToGroup = (groupId, userId) => {
  const groupInvitations = getChatgroupinvitationsFromUserId(groupId);
  return !!groupInvitations?.find((el) => el?.to_user?.id === userId);
};
